import { ModelWithId } from '@casops/store/apis/commonModels';

export const getDefaultModelArg = <TData extends ModelWithId>({ id }: TData): ModelWithId => ({
  id,
});
